import { Box, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslationContext } from '../../context/TranslationContext';

type AllDayCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled: boolean;
};

const AllDayCheckbox = ({ checked, onChange, disabled }: AllDayCheckboxProps) => {
  const t = useTranslationContext();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            color="secondary"
          />
        }
        label={t('global.allDay', 'Todo el día')}
      />
    </Box>
  );
};

export default AllDayCheckbox;
